module.exports = __webpack_public_path__ + "img/hilo_board.2d55c9d7.png";